<template>
    <div class="recharge-page">
        <!-- 时间查询和操作按钮区域 -->
        <div class="search-bar">
            <el-date-picker v-model="startTime" type="date" placeholder="选择开始时间"
                style="width: 150px; margin-right: 10px;" value-format="yyyy-MM-dd" clearable></el-date-picker>
            <el-date-picker v-model="endTime" type="date" placeholder="选择结束时间" style="width: 150px; margin-right: 10px;"
                value-format="yyyy-MM-dd" clearable></el-date-picker>
            <el-button type="primary" @click="handleQuery" :loading="queryLoading">查询</el-button>
            <el-button @click="handleReset" style="margin-left: 10px;">重置</el-button>
        </div>

        <!-- 充值列表表格 -->
        <el-table :data="rechargeList" border style="width: 100%; margin-top: 20px;"
            :header-cell-style="{ background: '#f5f7fa', color: '#333' }" v-loading="tableLoading" empty-text="暂无充值记录数据"
            height="70vh">
            <el-table-column prop="rechargeUserId" label="充值人编号" min-width="100"></el-table-column>
            <el-table-column prop="rechargeUserName" label="充值人姓名" min-width="120"></el-table-column>
            <el-table-column prop="personAccount" label="个人账户充值金额" min-width="140">

            </el-table-column>
            <el-table-column prop="subsidyAccount" label="补贴账户充值金额" min-width="140">

            </el-table-column>
            <el-table-column prop="rechargeLogTime" label="充值时间" min-width="180"></el-table-column>
            <el-table-column prop="rechargeNumber" label="充值流水号" min-width="180">

            </el-table-column>
            <el-table-column prop="rechargeType" label="充值或减值" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag :type="getRechargeTypeTagType(scope.row.rechargeType)" size="small">
                        {{ getRechargeTypeName(scope.row.rechargeType) }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="moneySource" label="资金来源" width="100"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container" style="margin-top: 20px; text-align: right;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.totalCount" background
                :disabled="pagination.totalCount === 0"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RechargeList',
    data() {
        return {
            startTime: '', // 开始时间
            endTime: '', // 结束时间
            queryLoading: false, // 查询按钮加载状态
            tableLoading: false, // 表格加载状态
            rechargeList: [], // 充值列表数据
            // 分页参数
            pagination: {
                currentPage: 1, // 当前页码
                pageSize: 10,   // 每页条数
                totalCount: 0   // 总条数
            }
        };
    },
    created() {
        // 初始化默认查询今日数据
        this.initDefaultDate();
        this.getRechargeList();
    },
    methods: {
        // 初始化默认日期（今日）
        initDefaultDate() {
            const today = new Date();
            this.startTime = this.formatDate(today);
            this.endTime = this.formatDate(today);
        },
        formatIndex(row, column) {
            console.log(column);

            return (this.pagination.currentPage - 1) * this.pagination.pageSize + (this.rechargeList.indexOf(row) + 1);
        },

        // 根据充值类型值获取显示名称
        getRechargeTypeName(typeValue) {
            const typeKey = String(typeValue || '');
            const rechargeTypeMap = {
                '1': '现金',
                '2': '支票',
                '3': '微信',
                '4': '支付宝',
                '5': '银联',
                '6': '空充'
            };
            return rechargeTypeMap[typeKey] || `未知(${typeValue})`;
        },

        // 根据充值类型值获取标签样式
        getRechargeTypeTagType(typeValue) {
            const typeKey = String(typeValue || '');
            const typeTagMap = {
                '1': 'primary',
                '2': 'success',
                '3': 'warning',
                '4': 'info',
                '5': 'danger',
                '6': 'default' // 若Element不支持purple，用default（灰色）
            };
            return typeTagMap[typeKey] || 'default';
        },
        // 日期格式化（yyyy-MM-dd）
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        // 金额格式化（保留两位小数，空值显示0.00）
        formatAmount(amount) {
            return (Number(amount) || 0).toFixed(2);
        },

        // 获取充值记录列表
        async getRechargeList() {
            this.tableLoading = true;
            try {
                const url = 'https://www.zhongyanzhiye.com:8090/chelmeyAI/openAPI/selectRechargeLog';

                // 构造请求参数（适配接口要求）
                const requestParams = {
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize,
                    merchantId: 'jbtjbtct001', // 商户ID（根据实际业务调整）
                    startTime: this.startTime,
                    endTime: this.endTime
                };

                // 发送POST请求
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 如需Token认证，添加以下配置
                        // 'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(requestParams)
                });

                if (!response.ok) {
                    throw new Error(`接口请求失败: ${response.status}`);
                }

                const result = await response.json();

                this.rechargeList = result.result.rows || [];
                this.pagination.totalCount = result.result.total || 0;


                console.log('充值记录数据:', result);

            } catch (error) {
                console.error('获取充值记录失败:', error);
                this.rechargeList = [];
                this.pagination.totalCount = 0;
                this.$message.error('加载数据失败，请检查网络或稍后重试');
            } finally {
                this.tableLoading = false;
                this.queryLoading = false;
            }
        },

        // 查询按钮点击事件
        handleQuery() {
            // 验证时间选择
            if (!this.startTime || !this.endTime) {
                this.$message.warning('请选择开始时间和结束时间');
                return;
            }

            // 验证时间范围
            if (new Date(this.startTime) > new Date(this.endTime)) {
                this.$message.warning('开始时间不能晚于结束时间');
                return;
            }

            this.queryLoading = true;
            this.pagination.currentPage = 1; // 重置为第一页
            this.getRechargeList();
        },

        // 重置按钮点击事件
        handleReset() {
            this.initDefaultDate(); // 重置为今日
            this.pagination.currentPage = 1;
            this.getRechargeList();
        },

        // 每页条数改变
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.pagination.currentPage = 1; // 重置页码
            this.getRechargeList();
        },

        // 当前页码改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getRechargeList();
            // 滚动到表格顶部
            window.scrollTo(0, 200);
        }
    }
};
</script>

<style lang="scss" scoped>
.recharge-page {
    padding: 20px;
    background-color: #fff;
    min-height: calc(100vh - 40px);

    .search-bar {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    // 流水号省略号样式
    .ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        width: 100%;
    }

    // 分页容器样式
    .pagination-container {
        ::v-deep .el-pagination {
            --el-pagination-text-color: #666;
            --el-pagination-button-color: #409eff;
            --el-pagination-button-hover-color: #66b1ff;
        }
    }
}

// 加载状态样式优化
::v-deep .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.8);
}

::v-deep .el-loading-spinner {
    top: 45%;
}

// 表格样式优化
::v-deep .el-table {
    --el-table-row-hover-bg-color: #f8f9fa;
    --el-table-header-text-color: #333;
    --el-table-header-font-weight: 500;
}

// 标签样式优化
::v-deep .el-tag--success {
    --el-tag-bg-color: #f0f9ff;
    --el-tag-text-color: #13ce66;
    --el-tag-border-color: #e1f5fe;
}

::v-deep .el-tag--danger {
    --el-tag-bg-color: #fff2f0;
    --el-tag-text-color: #ff4d4f;
    --el-tag-border-color: #ffccc7;
}
</style>